import {Pagination} from '@store/common/pagination.model';
import {Invoice, InvoiceTypology} from '@store/invoices/invoices';
import I18n from '@utils/i18n.utils';
import {UserLight} from '@store/settings/users';
import {Colors} from '@constants/colors.constants';

export enum JobInvoiceStatus {
  PROCESSING = 'PROCESSING',
  TO_BE_VALIDATED = 'TO_BE_VALIDATED',
  ENDED = 'ENDED',
  EMPTY = 'EMPTY',
  INVALIDATED = 'INVALIDATED'
}

export namespace JobInvoiceStatus {
  export const selectItems = () => [
    {
      label: I18n.t('global.jobInvoiceStatus.PROCESSING'),
      value: JobInvoiceStatus.PROCESSING,
      backgroundColor: Colors.white,
    },
    {
      label: I18n.t('global.jobInvoiceStatus.TO_BE_VALIDATED'),
      value: JobInvoiceStatus.TO_BE_VALIDATED,
      backgroundColor: Colors.toValidate,
    },
    {
      label: I18n.t('global.jobInvoiceStatus.ENDED'),
      value: JobInvoiceStatus.ENDED,
      backgroundColor: Colors.sent,
    },
    {
      label: I18n.t('global.jobInvoiceStatus.INVALIDATED'),
      value: JobInvoiceStatus.INVALIDATED,
      backgroundColor: Colors.error,
    },

  ];
}

export interface JobInvoiceDetails extends JobInvoice {
  clientInvoices: Invoice[];
}

export interface JobsInvoicePagination extends Pagination {
  data: JobInvoice[];
}


export interface JobInvoice {
  id: number;
  from: string;
  to: string;
  clientOrganisationIds: string[];
  clientOrganisations: { id: number; name: string }[];
  typologies: InvoiceTypology[];
  createdAt: string;
  processingEndedAt: string;
  validatedAt: string;
  status: JobInvoiceStatus;
  clientInvoicesGeneratedCount: number;
  clientInvoicesKeptCount: number;
  author: UserLight;
}

